{
  "version": 1,
  "asset_id": "e695e215-22a7-4376-ab87-eb643b1125a1",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e695e215-22a7-4376-ab87-eb643b1125a1/svc-ppc-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e695e215-22a7-4376-ab87-eb643b1125a1/svc-ppc-640.webp",
  "original_filename": "svc-ppc-640.webp",
  "size": 6148,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:54Z"
}
